import React from 'react'
import Button from "reactstrap/lib/Button"
import theme from 'vars/theme'

const StartFromBeginningButton = ({ onClick }: {
  onClick: () => void
}) => {
  return (
    <Button
      type="button"
      className="d-flex font-weight-bold rounded-pill"
      style={{
        width: 125,
        fontSize: 11,
        backgroundColor: theme.whitePrimary,
        color: theme.grayDark,
        border: `1px solid ${theme.blueSoft10}`,
        marginTop: '24px'
      }}
      color="secondary"
      onClick={onClick}
    >
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M7.6695 9.27192L10.9387 6.00275C11.1647 5.77675 11.53 5.77675 11.7536 6.00275L12.2968 6.546C12.5228 6.77192 12.5228 7.13734 12.2968 7.36092L9.97958 9.67817L12.2968 11.9955C12.5228 12.2215 12.5228 12.5868 12.2968 12.8104L11.7536 13.3537C11.5277 13.5797 11.1622 13.5797 10.9387 13.3537L7.6695 10.0844C7.4435 9.86334 7.4435 9.49792 7.6695 9.27192Z" fill={theme.blueSoft10} />
      </svg>
      <span>はじめに戻る</span>
    </Button>
  )
}

export default StartFromBeginningButton
